exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pointer {\r\n    cursor: pointer;\r\n}\r\n.float-right {\r\n    float: right;\r\n}\r\n.float-left {\r\n    float: left;\r\n}\r\na.black-link, a.black-link:hover {\r\n    color: #000;\r\n}", ""]);

// exports
